import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Containers
const MainTemplate = () =>
    import ('@/views/MainTemplate')
const MainView = () =>
    import ('@/views/MainView')
const LoginView = () =>
    import ('@/views/Login')

//Personal
const PersonalIndex = () =>
    import ('@/views/personal/index')
const PersonalAgregar = () =>
    import ('@/views/personal/agregar')
const PersonalExpediente = () =>
    import ('@/views/personal/expediente')

//Puestos
const PuestosIndex = () =>
    import ('@/views/puestos/index')

//Dependencias
const DependenciasIndex = () =>
    import ('@/views/dependencias/index')

//Horarios
const HorariosIndex = () =>
    import ('@/views/horarios/index')
const HorariosConsultar = () =>
    import ('@/views/horarios/consultar')

//Asistencias
const AsistenciasIndex = () =>
    import ('@/views/asistencias/index')

//Vacaciones
const VacacionesIndex = () =>
    import ('@/views/vacaciones/index')

//Vacaciones
const LicenciasIndex = () =>
    import ('@/views/licencias/index')

//Incapacidad
const IncapacidadIndex = () =>
    import ('@/views/incapacidad/index')

//Festivos
const FestivosIndex = () =>
    import ('@/views/festivos/index')



export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/',
            redirect: '/login',
            name: 'Home',
            component: MainTemplate,
            children: [{
                    path: 'inicio',
                    name: 'Inicio',
                    component: MainView
                },

                //Personal
                {
                    path: 'personal',
                    name: 'Personal',
                    component: PersonalIndex
                },
                {
                    path: 'personal/agregar',
                    name: 'Agregar personal',
                    component: PersonalAgregar
                },
                {
                    path: 'personal/expediente/:id',
                    name: 'Expediente de personal',
                    component: PersonalExpediente
                },

                //Puestos
                {
                    path: 'puestos',
                    name: 'Puestos',
                    component: PuestosIndex
                },

                //Dependencias
                {
                    path: 'dependencias',
                    name: 'Dependencias',
                    component: DependenciasIndex
                },

                //Horarios
                {
                    path: 'horarios',
                    name: 'Horarios',
                    component: HorariosIndex
                },
                {
                    path: 'horarios/consultar/:id',
                    name: 'Consulta de horario',
                    component: HorariosConsultar
                },

                //Asistencias
                {
                    path: 'asistencias',
                    name: 'Asistencias',
                    component: AsistenciasIndex
                },

                //Vacaciones
                {
                    path: 'vacaciones',
                    name: 'Vacaciones',
                    component: VacacionesIndex
                },

                //Licencias
                {
                    path: 'licencias',
                    name: 'Licencias',
                    component: LicenciasIndex
                },

                //incapacidad
                {
                    path: 'incapacidad',
                    name: 'Incapacidad',
                    component: IncapacidadIndex
                },

                //Festivos
                {
                    path: 'festivos',
                    name: 'Festivos',
                    component: FestivosIndex
                },
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginView
        },
        // {
        //     //Cualquier ruta que no exista, se redireccionará al main
        //     path: '*',
        //     name: 'Not found',
        //     component: Page404
        // }
    ]
})